import { useState } from 'react';

import { RequestConfig } from '~/common/services/requests';
import { useRequests } from '../../contexts/RequestsContext';
import { useAsyncEffect } from '../useAsyncEffect.hook';
import { useEventHandler } from '../useEventHandler';

type DownloadRequest = {
  url: string;
  filename: string;
  params?: RequestConfig['params'];
};

export const useFileDownload = () => {
  const { platformRequest } = useRequests();
  const [isPending, setIsPending] = useState(false);
  const [downloadRequest, setDownloadRequest] =
    useState<DownloadRequest | null>(null);

  useAsyncEffect(
    async (getIsMounted) => {
      if (!downloadRequest) return;
      setIsPending(true);
      try {
        const blob = await platformRequest<Blob>({
          method: 'GET',
          url: downloadRequest.url,
          params: downloadRequest.params,
          responseType: 'blob',
        });
        const anchor = document.createElement('a');
        anchor.download = downloadRequest.filename;
        anchor.href = URL.createObjectURL(blob);
        anchor.click();
      } finally {
        if (getIsMounted()) {
          setIsPending(false);
          setDownloadRequest(null);
        }
      }
    },
    [downloadRequest],
  );

  const download = useEventHandler(
    (url: string, filename: string, params?: RequestConfig['params']) => {
      setDownloadRequest({ url, filename, params });
    },
  );

  return { download, isPending };
};
